export default __webpack_public_path__ + "static/media/GiraffePage2.b2f54ed1.txt";